import {
  Button,
  Col,
  CreateButton,
  DateField,
  Divider,
  Form,
  Icons,
  Input,
  List,
  RefreshButton,
  Row,
  Space,
  Table,
  useModalForm,
  useTable,
  DeleteButton,
  EditButton,
} from '@pankod/refine-antd'
import ProjectCreate from 'pages/project_setup/create'
import ProjectConfigEdit from 'pages/project_setup/edit'
import { useState } from 'react'
import { useReportTheme } from 'utility/masterData'

const ProjectListComponent = () => {
  const [isLoading, setIsLoading] = useState(false)
  // const reportThemeLists = useReportTheme(true, [])

  // fetching details for table
  const { tableProps, tableQueryResult, searchFormProps } = useTable({
    resource: 'project_config',
    initialSorter: [
      {
        field: 'updated_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'report_theme_ids', 'duration', 'description', 'created_at', 'updated_at', 'active'],
    },
    permanentFilter: [{ field: 'active', operator: 'eq', value: true }],
    onSearch(data: any) {
      return [{ field: 'name', operator: 'contains', value: `%${data?.name}%` }]
    },
  })

  //create modal props
  const {
    formProps,
    modalProps: createModalProps,
    show: showCreateModal,
    close: closeCreateModal,
  } = useModalForm({
    resource: 'project_config',
    action: 'create',
    redirect: false,
  })

  //edit modal
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: showEditModal,
    close: closeEditModal,
  } = useModalForm({
    resource: 'project_config',
    action: 'edit',
    redirect: false,
    metaData: {
      fields: ['id', 'name', 'report_theme_ids', 'duration', 'description', 'created_at', 'updated_at', 'active'],
    },
  })

  const createButtonProps = {
    onClick: () => {
      setIsLoading(true)
      showCreateModal()
    },
    loading: isLoading,
  }

  // refetch function
  const refetchData = () => {
    tableQueryResult?.refetch()
  }

  const renderItems = (value: any, type: string) => {
    try {
      let renderValue = ``
      if (type === 'reportthemes') {
        // if (value) {
        //   const referenceList = reportThemeLists?.options || []
        //   if (referenceList.length > 0 && value?.length > 0) {
        //     for (let i = 0; i < value.length; i++) {
        //       const rtId = value[i]
        //       const rtDetails = referenceList.find((item: any) => {
        //         if (item?.value === rtId) {
        //           return item
        //         }
        //       })
        //       if (rtDetails) {
        //         renderValue = renderValue.concat(rtDetails.label, ',')
        //       }
        //     }
        //   }
        // }
        // renderValue = renderValue.substring(0, renderValue.length - 1)
      } else if (type === 'date') {
        if (value && value?.start_date && value?.end_date) {
          renderValue = `${value?.start_date} To ${value?.end_date}`
        }
      }
      return renderValue || 'N/A'
    } catch (err) {
      console.log(err)
      return 'N/A'
    }
  }

  return (
    <List title="Project Configuration">
      <Row gutter={[24, 16]}>
        {/* search items */}
        <Col xs={24} sm={24} md={14} lg={16} xl={18}>
          <Form {...searchFormProps}>
            <Space>
              <Form.Item name="name">
                <Input
                  placeholder="Search by name"
                  suffix={
                    <>
                      <Icons.SearchOutlined style={{ cursor: 'pointer' }} onClick={searchFormProps.form?.submit} />
                      <Icons.CloseCircleOutlined
                        style={{ cursor: 'pointer', marginLeft: '8px' }}
                        onClick={() => {
                          searchFormProps?.form?.setFieldsValue({ name: '' })
                          searchFormProps.form?.submit()
                        }}
                      />
                    </>
                  }
                />
              </Form.Item>
            </Space>
          </Form>
        </Col>
        {/* extra buttons */}
        <Col xs={24} sm={24} md={10} lg={8} xl={6}>
          <Space>
            <CreateButton {...createButtonProps} />
            <RefreshButton onClick={refetchData} />
          </Space>
        </Col>
      </Row>
      <Divider />
      <Table {...tableProps} rowKey="id" size="small" loading={tableQueryResult?.isFetching}>
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column dataIndex="description" title="Description" />
        {/* <Table.Column dataIndex="report_theme_ids" title="Report Themes" width="30%" render={value => renderItems(value, 'reportthemes')} /> */}
        <Table.Column dataIndex="duration" title="Project Duration" render={value => renderItems(value, 'date')} />
        <Table.Column dataIndex="updated_at" title="Last Update" render={value => <DateField value={value} format="LLL" />} />
        <Table.Column
          dataIndex="id"
          title="Actions"
          render={(value, record: any) => {
            return (
              <div>
                <DeleteButton
                  size="small"
                  resource="project_config"
                  resourceNameOrRouteName="project_config"
                  style={{ marginRight: '5px' }}
                  icon={<Icons.DeleteOutlined />}
                  recordItemId={value}
                  type="dashed"
                  hideText
                  danger
                />
                <EditButton
                  hideText
                  size="small"
                  icon={<Icons.EditOutlined />}
                  type="dashed"
                  recordItemId={record.id}
                  onClick={() => {
                    showEditModal(record.id)
                  }}
                />
              </div>
            )
          }}
        />
      </Table>
      <ProjectCreate
        formProps={formProps}
        modalProps={createModalProps}
        refetchData={refetchData}
        close={() => {
          setIsLoading(false)
          closeCreateModal()
        }}
      />
      <ProjectConfigEdit modalProps={editModalProps} formProps={editFormProps} refetchData={refetchData}  />
    </List>
  )
}

export default ProjectListComponent
